/* Medal Builder – full UX + hydration build (WITH BOX STEP + ribbon/box optional)
   Matches sections/medal-builder.liquid (6 steps):
   1 Medal (required) · 2 Centre (required) · 3 Ribbon (optional) · 4 Box (optional) · 5 Engraving (optional) · 6 Review
*/

(function () {
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.medal-builder').forEach(initBuilder);
  });

  // =========================
  // Fetch/Hydration Helpers
  // =========================
  async function fetchCollectionPage(handle, page, limit = 50) {
    const url = `/collections/${encodeURIComponent(handle)}/products.json?limit=${limit}&page=${page}`;
    const res = await fetch(url, { credentials: 'same-origin' });
    if (!res.ok) return { products: [] };
    return res.json();
  }

  async function fetchAllCollectionProducts(handle) {
    const all = [];
    let page = 1;
    while (true) {
      const data = await fetchCollectionPage(handle, page, 50);
      const arr = Array.isArray(data.products) ? data.products : [];
      if (!arr.length) break;
      all.push(...arr);
      page += 1;
      if (page > 100) break; // safety cap
    }
    return all;
  }

  function mapProductsToItems(products) {
    return products.map(p => {
      const firstImage =
        (p.images && p.images[0] && (p.images[0].src || p.images[0].url)) ||
        (p.image && (p.image.src || p.image.url)) || '';
      const variant = (p.variants || [])[0] || {};
      const priceCents = variant.price ? Math.round(parseFloat(variant.price) * 100) : 0;
      const tags = Array.isArray(p.tags)
        ? p.tags
        : (p.tags ? String(p.tags).split(',').map(t => t.trim()) : []);
      return {
        id: Number(variant.id),
        product_id: Number(p.id),
        title: p.title || '',
        price: Number.isFinite(priceCents) ? priceCents : 0,
        image: firstImage,
        preview: firstImage,
        tags: tags.filter(Boolean)
      };
    }).filter(x => x.id);
  }

  function dedupeByProductId(items) {
    const seen = new Set();
    const out = [];
    for (const it of items) {
      if (seen.has(it.product_id)) continue;
      seen.add(it.product_id);
      out.push(it);
    }
    return out;
  }

  // =========================
  // Main Builder
  // =========================
  function initBuilder(root) {
    const sectionId = root.dataset.sectionId;
    const data = (window.MedalBuilder || {})[sectionId];
    if (!data) return;

    // ----- State -----
    const state = { step: 1, base: null, centre: null, ribbon: null, box: null, engraving: '', qty: 1, selfAssemble: false };

    // --- Design tokens for your button system ---
    const DESIGN_SOLID   = ['#button', '@display-style:solid', '@size:md', 'mb-btn'];
    const DESIGN_OUTLINE = ['#button', '@display-style:outline', '@size:md', 'mb-btn'];
    function addTokens(el, tokens){ if(!el) return; tokens.forEach(t => el.classList.add(t)); }
    function applyDesignClasses(){
      [nextBtn, stickyNext, nextTop1, nextTop2, nextTop3, nextTop4, nextTop5, addBtn].forEach(el => addTokens(el, DESIGN_SOLID));
      [prevBtn, stickyPrev].forEach(el => addTokens(el, DESIGN_OUTLINE));
      stepper?.querySelectorAll('.mb-step').forEach(el => el.classList.add('#button','@size:md','mb-btn'));
    }
    function updateStepperDesignClasses(){
      stepper?.querySelectorAll('.mb-step').forEach(el => {
        const isActive = el.classList.contains('is-active');
        el.classList.remove('@display-style:solid','@display-style:outline');
        el.classList.add(isActive ? '@display-style:solid' : '@display-style:outline');
      });
    }

    // ----- Elements -----
    const stepper        = root.querySelector('#mb-stepper-' + sectionId);
    const panels         = root.querySelectorAll('[data-step-panel]');

    const baseGrid       = root.querySelector('#mb-medals-' + sectionId);
    const baseSearch     = root.querySelector('#mb-base-search-' + sectionId);

    const centreGrid     = root.querySelector('#mb-centres-' + sectionId);
    const centreSearch   = root.querySelector('#mb-centre-search-' + sectionId);
    const centreFilters  = root.querySelector('#mb-centre-filters-' + sectionId);

    const ribbonGrid     = root.querySelector('#mb-ribbons-' + sectionId);
    const ribbonSearch   = root.querySelector('#mb-ribbon-search-' + sectionId);

    const boxGrid        = root.querySelector('#mb-boxes-' + sectionId);
    const boxSearch      = root.querySelector('#mb-box-search-' + sectionId);

    const engravingInput = root.querySelector('#mb-engraving-' + sectionId);
    const engrCount      = root.querySelector('#mb-engrave-count-' + sectionId);

    const summaryEl      = root.querySelector('#mb-summary-' + sectionId);
    const priceEl        = root.querySelector('#mb-price-' + sectionId);
    const subpriceEl     = root.querySelector('#mb-subprice-' + sectionId);
    const qtyInput       = root.querySelector('#mb-qty-' + sectionId);
    const addBtn         = root.querySelector('#mb-add-' + sectionId);

    const nextBtn        = root.querySelector('#mb-next-' + sectionId);
    const prevBtn        = root.querySelector('#mb-prev-' + sectionId);

    // Sticky nav
    const stickyStatus   = root.querySelector('#mb-sticky-status-' + sectionId);
    const stickyNext     = root.querySelector('#mb-next-sticky-' + sectionId);
    const stickyPrev     = root.querySelector('#mb-prev-sticky-' + sectionId);

    // Top-right Next buttons per step
    const nextTop1       = root.querySelector('#mb-next-top-1-' + sectionId);
    const nextTop2       = root.querySelector('#mb-next-top-2-' + sectionId);
    const nextTop3       = root.querySelector('#mb-next-top-3-' + sectionId);
    const nextTop4       = root.querySelector('#mb-next-top-4-' + sectionId);
    const nextTop5       = root.querySelector('#mb-next-top-5-' + sectionId);

    // Review thumbnails
    const reviewBaseImg    = root.querySelector('img[data-review="base"]');
    const reviewCentreImg  = root.querySelector('img[data-review="centre"]');
    const reviewRibbonImg  = root.querySelector('img[data-review="ribbon"]');
    const reviewBoxImg     = root.querySelector('img[data-review="box"]');

    // Progress bar
    const progressFill   = root.querySelector('#mb-progress-fill-' + sectionId);
    const progressLabel  = root.querySelector('#mb-progress-label-' + sectionId);

    // Helpers per step (optional if present)
    const help1 = root.querySelector('#mb-help-1-' + sectionId);
    const help2 = root.querySelector('#mb-help-2-' + sectionId);
    const help3 = root.querySelector('#mb-help-3-' + sectionId);
    const help4 = root.querySelector('#mb-help-4-' + sectionId);

    // Discount checkbox   
    const selfAsmChk = root.querySelector('#mb-selfasm-' + sectionId);


    // keys that are optional and can be deselected
    const OPTIONAL_KEYS = new Set(['ribbon','box']);


    // ----- Step gating (required: medal + centre only) -----
    function canProceedFrom(step) {
      if (step === 1) return !!state.base;
      if (step === 2) return !!state.centre;
      // 3 (ribbon) optional, 4 (box) optional, 5 (engraving) optional
      return true;
    }
    function setAddBtnState() {
      if (addBtn) addBtn.disabled = !(state.base && state.centre);
    }
    function setNextEnabledForCurrentStep() {
      let enabled;
      if (state.step === 6) {
        // On Review, enable only if cart is actually addable
        enabled = !!(state.base && state.centre);
      } else {
        enabled = canProceedFrom(state.step);
      }

      if (nextBtn) nextBtn.disabled = !enabled;
      if (stickyNext) stickyNext.disabled = !enabled;

      const tops = { 1: nextTop1, 2: nextTop2, 3: nextTop3, 4: nextTop4, 5: nextTop5 };
      Object.entries(tops).forEach(([s, btn]) => {
        if (!btn) return;
        btn.disabled = Number(s) !== state.step ? true : !enabled;
      });
    }


    function updateStickyStatus() {
      if (stickyStatus) {
        const titles = {
          1: 'Pick your medal',
          2: 'Pick your centre',
          3: 'Pick your ribbon (optional)',
          4: 'Pick a medal box (optional)',
          5: 'Add engraving (optional)',
          6: 'Review & add to cart'
        };
        stickyStatus.textContent = `Step ${state.step} of 6 · ${titles[state.step]}`;
      }

      // Swap the sticky right button label on the Review step
      if (stickyNext) {
        stickyNext.textContent = (state.step === 6) ? 'Add to cart' : 'Next';
      }
    }


    function updateProgress() {
      // Only required selections contribute to completion
      const done = (state.base ? 1 : 0) + (state.centre ? 1 : 0);
      const pct  = Math.round((done / 2) * 100);
      if (progressFill)  progressFill.style.width = pct + '%';
      if (progressLabel) progressLabel.textContent = `${pct}% complete · ${done}/2 required selected`;
    }

    function updateHelpers() {
      if (help1) { help1.textContent = state.base   ? '✓ Medal selected'  : 'Select a medal to continue';  help1.classList.toggle('is-done', !!state.base); }
      if (help2) { help2.textContent = state.centre ? '✓ Centre selected' : 'Select a centre to continue'; help2.classList.toggle('is-done', !!state.centre); }
      if (help3) { help3.textContent = state.ribbon ? '✓ Ribbon selected (optional)' : 'Ribbon is optional'; }
      if (help4) { help4.textContent = state.box    ? '✓ Box selected (optional)'    : 'Box is optional'; }
    }

    function pulse(el) {
      if (!el) return;
      el.classList.remove('pulse'); void el.offsetWidth; el.classList.add('pulse');
    }

    // ----- Initial render -----
    renderBases();
    buildCentreFilters();
    renderCentres();
    renderRibbons();
    renderBoxes();
    updateSummary();
    applyDesignClasses();
    updateStepperDesignClasses();
    syncReviewImages();
    updateStickyStatus();
    updateProgress();
    updateHelpers();
    setAddBtnState();
    setNextEnabledForCurrentStep();

    // Hydrate full collections to include all pages
    hydrateAll().catch(console.error);

    async function hydrateAll() {
      const handles = (data.handles || {});
      // CENTRES
      if (handles.centres) {
        const products = await fetchAllCollectionProducts(handles.centres);
        if (products.length) {
          const mapped = dedupeByProductId(mapProductsToItems(products));
          const byId = new Map((data.centres || []).map(i => [i.product_id, i]));
          for (const m of mapped) byId.set(m.product_id, Object.assign(byId.get(m.product_id) || {}, m));
          data.centres = Array.from(byId.values());
          const active = centreFilters?.querySelector('button.is-active');
          const tag = active ? (active.dataset.tag === 'All' ? null : active.dataset.tag) : null;
          const q = centreSearch?.value.trim() || '';
          renderCentres(tag, q);
        }
      }
      // RIBBONS
      if (handles.ribbons) {
        const products = await fetchAllCollectionProducts(handles.ribbons);
        if (products.length) {
          const mapped = dedupeByProductId(mapProductsToItems(products));
          const byId = new Map((data.ribbons || []).map(i => [i.product_id, i]));
          for (const m of mapped) byId.set(m.product_id, Object.assign(byId.get(m.product_id) || {}, m));
          data.ribbons = Array.from(byId.values());
          const q = ribbonSearch?.value.trim() || '';
          renderRibbons(q);
        }
      }
      // BOXES
      if (handles.boxes) {
        const products = await fetchAllCollectionProducts(handles.boxes);
        if (products.length) {
          const mapped = dedupeByProductId(mapProductsToItems(products));
          const byId = new Map((data.boxes || []).map(i => [i.product_id, i]));
          for (const m of mapped) byId.set(m.product_id, Object.assign(byId.get(m.product_id) || {}, m));
          data.boxes = Array.from(byId.values());
          const q = boxSearch?.value?.trim() || '';
          renderBoxes(q);
        }
      }
      // BASES (optional)
      if (handles.bases) {
        const products = await fetchAllCollectionProducts(handles.bases);
        if (products.length) {
          const mapped = dedupeByProductId(mapProductsToItems(products));
          const byId = new Map((data.bases || []).map(i => [i.product_id, i]));
          for (const m of mapped) byId.set(m.product_id, Object.assign(byId.get(m.product_id) || {}, m));
          data.bases = Array.from(byId.values());
          const q = baseSearch?.value.trim() || '';
          renderBases(q);
        }
      }
      // Refresh UX state after hydration
      updateProgress();
      setAddBtnState();
      setNextEnabledForCurrentStep();
    }

    // ----- Stepper click (jump allowed) -----
    stepper?.addEventListener('click', (e) => {
      const btn = e.target.closest('.mb-step'); if (!btn) return;
      goToStep(Number(btn.dataset.step));
    });

    // ----- Next/Back (inline, sticky, and top-right) -----
    const onNext = () => {
      if (state.step === 6) {
        // Final step: act as Add to cart
        onAddToCart();
        return;
      }

      if (!canProceedFrom(state.step)) {
        alert(state.step === 1 ? 'Please choose a medal.' : 'Please choose a centre.');
        return;
      }

      goToStep(Math.min(6, state.step + 1));
      pulse(stickyNext);
      const tops = {1:nextTop1,2:nextTop2,3:nextTop3,4:nextTop4,5:nextTop5};
      pulse(tops[state.step]);
    };

    const onPrev = () => { goToStep(Math.max(1, state.step - 1)); };

    [nextBtn, stickyNext, nextTop1, nextTop2, nextTop3, nextTop4, nextTop5].forEach(b => b?.addEventListener('click', onNext));
    [prevBtn, stickyPrev].forEach(b => b?.addEventListener('click', onPrev));

    // ----- Search events -----
    baseSearch?.addEventListener('input', () => renderBases(baseSearch.value.trim()));
    centreSearch?.addEventListener('input', () => {
      let tag = null;
      if (centreFilters) {
        const active = centreFilters.querySelector('button.is-active');
        tag = active ? (active.dataset.tag === 'All' ? null : active.dataset.tag) : null;
      }
      renderCentres(tag, centreSearch.value.trim());
    });
    ribbonSearch?.addEventListener('input', () => renderRibbons(ribbonSearch.value.trim()));
    boxSearch?.addEventListener('input',    () => renderBoxes(boxSearch.value.trim()));

    // ----- Engraving -----
    engravingInput?.addEventListener('input', () => {
      state.engraving = engravingInput.value.trim();
      if (engrCount) engrCount.textContent = String(Math.min(100, state.engraving.length));
      updateSummary();
      syncReviewImages();
    });

    // ----- Quantity -----
    qtyInput?.addEventListener('input', () => {
      const n = parseInt(qtyInput.value, 10);
      state.qty = isNaN(n) || n < 1 ? 1 : n;
      if (qtyInput.value !== String(state.qty)) qtyInput.value = String(state.qty);
      updateSummary();
    });

    // ----- Add to cart (delegated & robust) -----
    root.addEventListener('click', (e) => {
      const btn = e.target.closest('#mb-add-' + sectionId);
      if (!btn || btn.disabled) return;
      onAddToCart();
    });

    // ----- Discount checkbox ---- 
    selfAsmChk?.addEventListener('change', () => {
      state.selfAssemble = !!selfAsmChk.checked;
      updateSummary();
      setNextEnabledForCurrentStep();
    });


    // =====================================================================
    // RENDER HELPERS
    // =====================================================================

    function renderBases(q = '') {
      const ql = (q || '').toLowerCase();
      const items = (data.bases || []).filter(p => !ql || p.title.toLowerCase().includes(ql));
      renderCards(baseGrid, items, 'base');
    }

    function buildCentreFilters() {
      if (!centreFilters) return; // null-safe
      const tagCounts = {};
      (data.centres || []).forEach(c => (c.tags || []).forEach(t => { tagCounts[t] = (tagCounts[t] || 0) + 1; }));
      const topTags = Object.keys(tagCounts).sort((a,b) => tagCounts[b]-tagCounts[a]).slice(0, 12);
      centreFilters.innerHTML = ['All', ...topTags]
        .map((t, i) => `<button type="button" data-tag="${t}" class="${i === 0 ? 'is-active' : ''}">${escapeHtml(t)}</button>`)
        .join('');
      centreFilters.onclick = (e) => {
        const b = e.target.closest('button'); if (!b) return;
        centreFilters.querySelectorAll('button').forEach(x => x.classList.remove('is-active'));
        b.classList.add('is-active');
        const tag = b.dataset.tag === 'All' ? null : b.dataset.tag;
        renderCentres(tag, centreSearch?.value.trim() || '');
      };
    }

    function renderCentres(tag = null, q = '') {
      const ql = (q || '').toLowerCase();
      const items = (data.centres || []).filter(c => {
        const okTag = !tag || (c.tags || []).includes(tag);
        const okQ = !ql || c.title.toLowerCase().includes(ql);
        return okTag && okQ;
      });
      if (!centreGrid) return;
      centreGrid.innerHTML = items.map(cardTpl('centre')).join('');
      centreGrid.onclick = pickHandler(items, 'centre');
    }

    function renderRibbons(q = '') {
      const ql = (q || '').toLowerCase();
      const items = (data.ribbons || []).filter(p => !ql || p.title.toLowerCase().includes(ql));
      renderCards(ribbonGrid, items, 'ribbon', { showNone: true });
    }

    function renderBoxes(q = '') {
      const ql = (q || '').toLowerCase();
      const items = (data.boxes || []).filter(p => !ql || p.title.toLowerCase().includes(ql));
      renderCards(boxGrid, items, 'box', { showNone: true });
    }


    function renderCards(container, items, key, opts = {}) {
      if (!container) return;

      // If this key is optional, "None" is selected when state[key] is null
      const isOptional = OPTIONAL_KEYS?.has?.(key);
      const noneSelected = isOptional && !state[key];

      const noneCard = opts.showNone ? `
        <button class="mb-card ${noneSelected ? 'is-selected' : ''}" type="button"
                data-pick data-key="${key}" data-id="none">
          <div class="mb-card__title">None</div>
        </button>` : '';

      container.innerHTML = noneCard + items.map(cardTpl(key)).join('');
      container.onclick = pickHandler(items, key);
    }



    function cardTpl(key) {
      return (item) => `
        <button class="mb-card" type="button" data-pick data-key="${key}" data-id="${item.id}">
          <img loading="lazy" src="${item.image || item.preview}" alt="${escapeHtml(item.title)}">
          <div class="mb-card__title">${escapeHtml(item.title)}</div>
        </button>`;
    }

    function pickHandler(items, key){
      return (e) => {
        const container = e.currentTarget;
        const card = e.target.closest('[data-pick]');
        if (!card) return;

        const rawId = card.dataset.id;

        // Handle the "None" pseudo-card for optional keys
        if (rawId === 'none' && OPTIONAL_KEYS.has(key)) {
          state[key] = null;
          // clear all selections, then highlight the None card
          container.querySelectorAll('.mb-card').forEach(el => el.classList.remove('is-selected'));
          const noneBtn = container.querySelector('[data-id="none"]');
          if (noneBtn) noneBtn.classList.add('is-selected');

          updateSummary(); syncReviewImages(); updateProgress(); updateHelpers();
          setAddBtnState(); setNextEnabledForCurrentStep();

          // subtle UX nudges
          document.querySelector('.mb-sticky-nav')?.scrollIntoView({ block: 'end', behavior: 'smooth' });
          pulse(stickyNext);
          const tops = {1:nextTop1,2:nextTop2,3:nextTop3,4:nextTop4,5:nextTop5};
          pulse(tops[state.step]);
          return;
        }

        const id = Number(rawId);
        const sel = items.find(i => i.id === id);
        if (!sel) return;

        const alreadySelected = state[key]?.id === sel.id;

        if (OPTIONAL_KEYS.has(key) && alreadySelected) {
          // toggle OFF for optional keys when clicking the same item
          state[key] = null;
          container.querySelectorAll('.mb-card').forEach(el => el.classList.remove('is-selected'));
          const noneBtn = container.querySelector('[data-id="none"]');
          if (noneBtn) noneBtn.classList.add('is-selected');
        } else {
          // select this item
          state[key] = sel;
          container.querySelectorAll('.mb-card').forEach(el => el.classList.remove('is-selected'));
          const btn = container.querySelector(`[data-id="${sel.id}"]`);
          if (btn) btn.classList.add('is-selected');
        }

        updateSummary(); syncReviewImages(); updateProgress(); updateHelpers();
        setAddBtnState(); setNextEnabledForCurrentStep();

        // subtle UX nudges
        document.querySelector('.mb-sticky-nav')?.scrollIntoView({ block: 'end', behavior: 'smooth' });
        pulse(stickyNext);
        const tops = {1:nextTop1,2:nextTop2,3:nextTop3,4:nextTop4,5:nextTop5};
        pulse(tops[state.step]);
      };
    }



    function goToStep(step) {
      state.step = step;

      // Toggle active state on the stepper pills
      stepper?.querySelectorAll('.mb-step').forEach((b) => {
        b.classList.toggle('is-active', Number(b.dataset.step) === step);
      });

      // Update stepper design tokens (solid/outline)
      updateStepperDesignClasses();

      // Show only the active panel
      panels.forEach((p) => { p.hidden = Number(p.dataset.stepPanel) !== step; });

      // Update sticky status + progress + Next disabled state
      updateStickyStatus();
      updateProgress();
      setNextEnabledForCurrentStep();

      // Refresh review UI when arriving on step 6
      if (step === 6) {
        updateSummary();
        syncReviewImages();
      }
    }

    function updateSummary() {
      const items = [];
      if (state.base)   items.push(`<div><strong>Medal:</strong> ${escapeHtml(state.base.title)}</div>`);
      if (state.centre) items.push(`<div><strong>Centre:</strong> ${escapeHtml(state.centre.title)}</div>`);
      if (state.ribbon) items.push(`<div><strong>Ribbon:</strong> ${escapeHtml(state.ribbon.title)}</div>`);
      if (state.box)    items.push(`<div><strong>Box:</strong> ${escapeHtml(state.box.title)}</div>`);
      if (state.engraving) items.push(`<div><strong>Engraving:</strong> “${escapeHtml(state.engraving)}”</div>`);
      if (summaryEl) summaryEl.innerHTML = items.join('') || '<em>Please complete your selections.</em>';

      // Per-unit price: medal + centre + (opt) ribbon + (opt) box + (opt) £1 engraving
      const medalP  = Number(state.base?.price   || 0);
      const centreP = Number(state.centre?.price || 0);
      const ribbonP = Number(state.ribbon?.price || 0);
      const boxP    = Number(state.box?.price    || 0);
      const engrP   = state.engraving ? 100 : 0; // £1 per medal if any text
      const unit    = medalP + centreP + ribbonP + boxP + engrP;
      const qty     = Math.max(1, state.qty);
      const total   = unit * qty;

      if (!priceEl || !subpriceEl) return;

      if (state.selfAssemble) {
        const discounted = Math.round(total * 0.8);
        priceEl.innerHTML = `Total <small>(after self-assemble 20%)</small>: ${formatMoney(discounted)}`;
        subpriceEl.innerHTML = `<span style="text-decoration:line-through; opacity:.7;">${formatMoney(total)}</span> &nbsp; You save ${formatMoney(total - discounted)}`;
      } else {
        priceEl.textContent = 'Total: ' + formatMoney(total);
        subpriceEl.textContent = `(£ per medal: ${formatMoney(unit)} × ${qty})`;
      }
    }


    function syncReviewImages() {
      if (reviewBaseImg)   { reviewBaseImg.src   = state.base?.preview   || ''; reviewBaseImg.style.display   = state.base   ? 'block' : 'none'; }
      if (reviewCentreImg) { reviewCentreImg.src = state.centre?.preview || ''; reviewCentreImg.style.display = state.centre ? 'block' : 'none'; }
      if (reviewRibbonImg) { reviewRibbonImg.src = state.ribbon?.preview || ''; reviewRibbonImg.style.display = state.ribbon ? 'block' : 'none'; }
      if (reviewBoxImg)    { reviewBoxImg.src    = state.box?.preview    || ''; reviewBoxImg.style.display    = state.box    ? 'block' : 'none'; }
    }

    // =====================================================================
    // CART (robust add with sequential fallback + Flow flag)
    // =====================================================================
    // =====================================================================
// CART (robust add + self-assemble discount redirect)
// =====================================================================
async function onAddToCart() {
  if (!state.base || !state.centre) {
    alert('Please choose at least a medal and a centre.');
    return;
  }

  const qty = Math.max(1, state.qty);
  const groupId = 'MB-' + Math.random().toString(36).slice(2, 9);

  const lines = [];

  // Base (priced)
  lines.push({
    id: state.base.id, quantity: qty,
    properties: {
      _mb_group: groupId, _mb_role: 'base',
      Centre: state.centre?.title || 'None',
      Ribbon: state.ribbon?.title || 'None',
      Box: state.box?.title || 'None',
      Engraving: state.engraving || 'None'
    }
  });

  // Centre (priced)
  lines.push({ id: state.centre.id, quantity: qty, properties: { _mb_group: groupId, _mb_role: 'centre' } });

  // Ribbon (optional, priced)
  if (state.ribbon) {
    lines.push({ id: state.ribbon.id, quantity: qty, properties: { _mb_group: groupId, _mb_role: 'ribbon' } });
  }

  // Box (optional, priced)
  if (state.box) {
    lines.push({ id: state.box.id, quantity: qty, properties: { _mb_group: groupId, _mb_role: 'box' } });
  }

  // Engraving (£1 per medal) if any text entered
  if (state.engraving && data.engravingProductId) {
    lines.push({ id: Number(data.engravingProductId), quantity: qty, properties: { _mb_group: groupId, _mb_role: 'engraving' } });
  }

  // Helper to add items
  const addItems = async (items) => {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items })
    });
    const text = await res.text();
    let payload; try { payload = JSON.parse(text); } catch { payload = text; }
    return { ok: res.ok, status: res.status, payload };
  };

  const originalText = addBtn?.textContent;
  if (addBtn) { addBtn.textContent = 'Adding…'; addBtn.disabled = true; }

  try {
    // Tag cart attributes (for Flow/analytics) including self-assemble choice
    try {
      await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({
          attributes: {
            medal_builder: 'true',
            mb_group: groupId,
            mb_self_assemble: state.selfAssemble ? 'true' : 'false'
          }
        })
      });
    } catch (e) { console.warn('Failed to set cart attributes', e); }

    // Fast path: bulk add
    let bulk = await addItems(lines);
    if (!bulk.ok) {
      // Fallback: sequential adds (clearer errors)
      for (const line of lines) {
        const r = await addItems([line]);
        if (!r.ok) {
          alert((r.payload?.description || r.payload?.message) || 'Unable to add an item.');
          break;
        }
      }
    }

    // Build redirect (with discount if opted-in)
    const code = (data.selfAssembleCode || 'SELFASSEMBLE20');
    let redirectUrl = '/cart';
    if (state.selfAssemble && code) {
      redirectUrl = `/discount/${encodeURIComponent(code)}?redirect=/cart`;
    }

    window.location.href = redirectUrl;

  } catch (err) {
    console.error('Add to cart error', err);
    alert('Sorry, something went wrong adding to cart.');
  } finally {
    if (addBtn) { addBtn.textContent = originalText || 'Add to cart'; addBtn.disabled = false; setAddBtnState(); }
  }
}


    async function flagCartAsMedalBuilder(groupId){
      try {
        await fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ attributes: { medal_builder:'true', mb_group: groupId } })
        });
      } catch(e){ console.warn('Failed to set cart attribute', e); }
    }
  }

  // =========================
  // Utils
  // =========================
  function formatMoney(cents) {
    try { return (cents / 100).toLocaleString(undefined, { style: 'currency', currency: 'GBP' }); }
    catch { return '£' + (cents / 100).toFixed(2); }
  }

  function escapeHtml(str) {
    return String(str || '')
      .replace(/&/g, '&amp;').replace(/</g, '&lt;')
      .replace(/>/g, '&gt;').replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }
})();
